/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { TimeUnits } from '../miscellaneous/timeUnits';

export const timeUnitMultipliers = {
  [TimeUnits.Sec]: 1,
  [TimeUnits.Min]: 60,
  [TimeUnits.Hour]: 3600,
  __fallback: 1,
};
